import { format } from 'date-fns'

export function fDate(date: any): string {
  return format(new Date(date), 'dd/MM/yyyy')
}

export function fDateTime(date: any): string {
  return format(new Date(date), 'dd/MM/yyyy, h:mm a')
}
